// Register a simple handlebars helper to encode url data
export default function handlebarsEncodeHelper(string) {

  // Return the encoded string
  return encodeURIComponent(string);
};